import { CTitleProducts } from './styled'

export default {
    'title-products': CTitleProducts
}